export const parseModelId = (id: string | undefined): number | undefined => {
  if (id === undefined || id === "") {
    return undefined
  }

  const parsed = Number.parseInt(id, 10)
  return Number.isNaN(parsed) ? undefined : parsed
}
